import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { GetAttendancesQuerySchema } from "@msuite/utils/schemas";
import { client } from "@/hono";

export function useUserAttendances(userId: string, query: Partial<GetAttendancesQuerySchema> = {}) {
	/** Query */
	const { pageSize = 5000, offset = 0, startDate, endDate } = query;

	const result = useQuery({
		queryKey: [
			"users",
			userId,
			"attendances",
			String(pageSize),
			String(offset),
			startDate ?? null,
			endDate ?? null,
		],
		queryFn: async () => {
			const response = await client.users[":userId"].attendances.$get({
				param: { userId },
				query: {
					pageSize: String(pageSize),
					offset: String(offset),
					startDate,
					endDate,
				},
			});
			const data = await responseHandler(response);
			return data.attendances;
		},
		enabled: !!userId,
	});

	/** Return */
	return { ...result, attendances: result.data };
}
